"use client"

import * as React from "react"
import Link from "next/link"

/**
 * A Link that prefetches once someone shows intent (hover, focus or touch), not merely on
 * screen: for the secondary links on every page, which otherwise cost each visitor a dozen
 * requests on arrival.
 */
export function IntentLink({
  onMouseEnter,
  onFocus,
  onTouchStart,
  ...props
}: Omit<React.ComponentProps<typeof Link>, "prefetch">) {
  const [intent, setIntent] = React.useState(false)
  return (
    <Link
      {...props}
      prefetch={intent ? null : false}
      onMouseEnter={(e) => {
        setIntent(true)
        onMouseEnter?.(e)
      }}
      onFocus={(e) => {
        setIntent(true)
        onFocus?.(e)
      }}
      onTouchStart={(e) => {
        setIntent(true)
        onTouchStart?.(e)
      }}
    />
  )
}
